// v10/src/version.js
// Inyectado en build-time vía env vars de Vercel.

// Si la env var no se expandió (caso Vercel sin haber configurado el valor real),
// el string llega literal como "$VERCEL_GIT_COMMIT_SHA". Tratamos eso como undefined.
const rawCommit = process.env.REACT_APP_BUILD_COMMIT;
const isExpandedVar = rawCommit && !rawCommit.startsWith('$');

export const APP_VERSION = process.env.REACT_APP_VERSION || '1.4.0-dev';
export const BUILD_COMMIT = isExpandedVar ? rawCommit : 'dev';
export const BUILD_DATE = process.env.REACT_APP_BUILD_DATE || new Date().toISOString().slice(0, 10);

/**
 * Imprime la versión en consola con estilo. Llamado en index.js al boot.
 */
export function logVersion() {
  const commitShort = (BUILD_COMMIT || 'dev').slice(0, 7);
  console.log(
    `%c[Condor360] v${APP_VERSION} · commit ${commitShort} · build ${BUILD_DATE}`,
    'color: #3b82f6; font-weight: bold; font-size: 12px;'
  );
}
